import ClockoutController from '../../core/clockout.controller';
import ReviewDetailDelegate from './reviews-detail.delegate.js';
import MultimediaController from '../support/multimedia.controller.js';
import Inherit from '../../core/inherit.js';

class ReviewDetailPageController extends Inherit(ClockoutController, MultimediaController, ReviewDetailDelegate) {
    state = {
        review: null,
        loading: true,
        error: null,
        createTicketModalOpen: false,
        ticketSubmitting: false,
        newTicketSubject: '',
        newTicketBody: '',
        newTicketAttachments: [],
        newTicketCategory: null,
        newTicketPriority: null,
    };

    async initialize() {
        const eventId = this.props.params.eventId;
        await this.loadReviewDetail(eventId);
    }

    async loadReviewDetail(eventId) {
        try {
            this.setState({ loading: true, error: null });
            const review = await this.data.fetchReviewDetail(eventId);
            this.setState({ review, loading: false });
        } catch (error) {
            console.error('Error loading review detail:', error);
            this.setState({ error: error.message, loading: false });
        }
    }

    handleOpenCreateTicketModal() {
        const { review } = this.state;
        this.setState({
            createTicketModalOpen: true,
            newTicketSubject: `[Review Feedback] - ID: ${review.event_id}`,
            newTicketBody: review.comments || '',
            newTicketAttachments: [],
            newTicketCategory: null,
            newTicketPriority: null,
        });
    }

    handleCloseCreateTicketModal() {
        this.setState({ createTicketModalOpen: false });
    }

    async handleCreateTicketSubmit() {
        const { review, newTicketSubject, newTicketBody, newTicketAttachments, newTicketCategory, newTicketPriority } = this.state;
        this.setState({ ticketSubmitting: true });
        try {
            // Upload attachments before creating ticket
            let files = [];
            if (newTicketAttachments.length > 0) {
                files = await this.uploadAttachments(newTicketAttachments, {
                    requestPresigned: this.data.requestPresignedTicketUrl.bind(this.data),
                    uploadToS3: this.data.uploadFileToS3.bind(this.data)
                });
            }

            const date = new Date(review.timestamp_ms);
            const result = await this.data.createTicketFromEvent({
                event_id: review.event_id,
                event_name: 'Advance_Feedback_Submitted',
                event_date: {
                    year: date.getUTCFullYear(),
                    month: date.getUTCMonth() + 1,
                    day: date.getUTCDate(),
                },
                ticket_data: {
                    subject: newTicketSubject,
                    body: newTicketBody,
                    category: newTicketCategory,
                    priority: newTicketPriority,
                },
                files,
            });
            this.setState({
                review: { ...review, associated_ticket: result.ticket },
                createTicketModalOpen: false,
            });
            this.props.notificationApi?.success({
                message: 'Ticket created',
                description: 'The support ticket was created successfully.',
            });
        } catch (error) {
            this.props.notificationApi?.error({
                message: 'Error',
                description: error.message || 'Failed to create the ticket',
            });
        } finally {
            this.setState({ ticketSubmitting: false });
        }
    }

    handleGoToTicket() {
        if (this.state.review?.associated_ticket?.id) {
            this.navigateTicket(this.state.review.associated_ticket.id);
        }
    }
}

export default ReviewDetailPageController;
